import { useState, useEffect } from 'react'
import { db } from '../../lib/supabase'

export default function AdminFAQs() {
  const [faqs, setFaqs] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [editingFaq, setEditingFaq] = useState(null)
  const [formData, setFormData] = useState({
    scope_type: 'page',
    scope_id: null,
    pagina: 'home',
    pregunta: '',
    respuesta: '',
    publicado: true,
    orden: 0
  })
  const [tiendas, setTiendas] = useState([])
  const [eventos, setEventos] = useState([])
  const [filterPage, setFilterPage] = useState('')
  const [filterStore, setFilterStore] = useState('')
  const [sortByOrder, setSortByOrder] = useState(false)

  useEffect(() => {
    loadFAQs()
    loadTiendas()
    loadEventos()
  }, [])

  const loadFAQs = async () => {
    try {
      setLoading(true)
      const { data, error } = await db.getAllFAQs()
      if (error) throw error
      setFaqs(data || [])
    } catch (error) {
      console.error('Error loading FAQs:', error)
      alert('Error al cargar FAQs')
    } finally {
      setLoading(false)
    }
  }

  const loadTiendas = async () => {
    const { data } = await db.getTiendas()
    setTiendas(data || [])
  }

  const loadEventos = async () => {
    const { data } = await db.getEventos()
    setEventos(data || [])
  }

  const handleOpenModal = (faq = null) => {
    if (faq) {
      setEditingFaq(faq)
      setFormData({
        scope_type: faq.scope_type,
        scope_id: faq.scope_id,
        pagina: faq.pagina || 'home',
        pregunta: faq.pregunta,
        respuesta: faq.respuesta,
        publicado: faq.publicado,
        orden: faq.orden
      })
    } else {
      setEditingFaq(null)
      setFormData({
        scope_type: 'page',
        scope_id: null,
        pagina: 'home',
        pregunta: '',
        respuesta: '',
        publicado: true,
        orden: 0
      })
    }
    setShowModal(true)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    try {
      const payload = {
        ...formData,
        scope_id: formData.scope_type === 'page' ? null : formData.scope_id,
        pagina: formData.scope_type === 'page' ? formData.pagina : null
      }

      if (editingFaq) {
        const { error } = await db.updateFAQ(editingFaq.id, payload)
        if (error) throw error
        alert('✅ FAQ actualizado exitosamente')
      } else {
        const { error } = await db.createFAQ(payload)
        if (error) throw error
        alert('✅ FAQ creado exitosamente')
      }

      setShowModal(false)
      loadFAQs()
    } catch (error) {
      console.error('Error saving FAQ:', error)
      alert('❌ Error al guardar FAQ')
    }
  }

  const handleDelete = async (id) => {
    if (!confirm('¿Estás seguro de eliminar este FAQ?')) return

    try {
      const { error } = await db.deleteFAQ(id)
      if (error) throw error
      alert('✅ FAQ eliminado exitosamente')
      loadFAQs()
    } catch (error) {
      console.error('Error deleting FAQ:', error)
      alert('❌ Error al eliminar FAQ')
    }
  }

  const getScopeName = (faq) => {
    if (faq.scope_type === 'page') return `Página: ${faq.pagina}`
    if (faq.scope_type === 'tienda') {
      const tienda = tiendas.find(t => t.id === faq.scope_id)
      return `Tienda: ${tienda?.nombre || 'N/A'}`
    }
    if (faq.scope_type === 'evento') {
      const evento = eventos.find(e => e.id === faq.scope_id)
      return `Evento: ${evento?.nombre || 'N/A'}`
    }
    return 'N/A'
  }

  // Filter and sort FAQs
  const filteredAndSortedFaqs = () => {
    let result = [...faqs]

    // Filter by page
    if (filterPage) {
      result = result.filter(faq => faq.scope_type === 'page' && faq.pagina === filterPage)
    }

    // Filter by store
    if (filterStore) {
      result = result.filter(faq => faq.scope_type === 'tienda' && faq.scope_id === filterStore)
    }

    // Sort by order
    if (sortByOrder) {
      result.sort((a, b) => a.orden - b.orden)
    }

    return result
  }

  return (
    <div style={{ padding: '2rem' }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '2rem'
      }}>
        <div>
          <h1 style={{ 
            fontSize: '2rem', 
            fontWeight: 'bold',
            marginBottom: '0.5rem'
          }}>❓ FAQs</h1>
          <p style={{ color: '#666' }}>
            Gestiona preguntas frecuentes por página, tienda o evento
          </p>
        </div>
        <button
          onClick={() => handleOpenModal()}
          style={{
            background: '#000',
            color: '#fff',
            padding: '0.75rem 1.5rem',
            borderRadius: '0.5rem',
            border: 'none',
            cursor: 'pointer',
            fontWeight: '600'
          }}
        >
          + Crear FAQ
        </button>
      </div>

      {/* Filters */}
      <div style={{
        background: '#f9f9f9',
        padding: '1.5rem',
        borderRadius: '0.5rem',
        marginBottom: '1.5rem',
        display: 'flex',
        gap: '1rem',
        flexWrap: 'wrap',
        alignItems: 'center'
      }}>
        <div style={{ flex: '1', minWidth: '200px' }}>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '0.5rem', fontSize: '0.875rem' }}>
            Filtrar por Página
          </label>
          <select
            value={filterPage}
            onChange={(e) => setFilterPage(e.target.value)}
            style={{
              width: '100%',
              padding: '0.5rem',
              border: '1px solid #d1d5db',
              borderRadius: '0.375rem',
              background: '#fff'
            }}
          >
            <option value="">Todas las páginas</option>
            <option value="home">Home</option>
            <option value="marcas">Marcas</option>
            <option value="eventos">Eventos</option>
            <option value="ubicanos">Ubícanos</option>
            <option value="contacto">Contacto</option>
            <option value="trabaja">Trabaja con Nosotros</option>
          </select>
        </div>

        <div style={{ flex: '1', minWidth: '200px' }}>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '0.5rem', fontSize: '0.875rem' }}>
            Filtrar por Tienda
          </label>
          <select
            value={filterStore}
            onChange={(e) => setFilterStore(e.target.value)}
            style={{
              width: '100%',
              padding: '0.5rem',
              border: '1px solid #d1d5db',
              borderRadius: '0.375rem',
              background: '#fff'
            }}
          >
            <option value="">Todas las tiendas</option>
            {tiendas.map(t => (
              <option key={t.id} value={t.id}>{t.nombre}</option>
            ))}
          </select>
        </div>

        <div style={{ flex: '0 0 auto' }}>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '0.5rem', fontSize: '0.875rem' }}>
            Ordenar
          </label>
          <label style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '0.5rem',
            padding: '0.5rem 0.75rem',
            background: '#fff',
            border: '1px solid #d1d5db',
            borderRadius: '0.375rem',
            cursor: 'pointer'
          }}>
            <input
              type="checkbox"
              checked={sortByOrder}
              onChange={(e) => setSortByOrder(e.target.checked)}
              style={{ cursor: 'pointer' }}
            />
            <span>Por numeración</span>
          </label>
        </div>

        {(filterPage || filterStore || sortByOrder) && (
          <div style={{ flex: '0 0 auto' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.875rem', opacity: 0 }}>
              .
            </label>
            <button
              onClick={() => {
                setFilterPage('')
                setFilterStore('')
                setSortByOrder(false)
              }}
              style={{
                padding: '0.5rem 1rem',
                background: '#EF4444',
                color: '#fff',
                border: 'none',
                borderRadius: '0.375rem',
                cursor: 'pointer',
                fontWeight: '500',
                fontSize: '0.875rem'
              }}
            >
              Limpiar filtros
            </button>
          </div>
        )}
      </div>

      {loading ? (
        <p>Cargando...</p>
      ) : (
        <div style={{
          background: '#fff',
          borderRadius: '0.5rem',
          border: '1px solid #e5e5e5',
          overflow: 'hidden'
        }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ background: '#f9f9f9' }}>
              <tr>
                <th style={{ padding: '1rem', textAlign: 'left', fontWeight: '600' }}>Pregunta</th>
                <th style={{ padding: '1rem', textAlign: 'left', fontWeight: '600' }}>Ámbito</th>
                <th style={{ padding: '1rem', textAlign: 'left', fontWeight: '600' }}>Orden</th>
                <th style={{ padding: '1rem', textAlign: 'left', fontWeight: '600' }}>Estado</th>
                <th style={{ padding: '1rem', textAlign: 'right', fontWeight: '600' }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {filteredAndSortedFaqs().map((faq) => (
                <tr key={faq.id} style={{ borderTop: '1px solid #e5e5e5' }}>
                  <td style={{ padding: '1rem' }}>
                    <div style={{ fontWeight: '500' }}>{faq.pregunta}</div>
                    <div style={{ fontSize: '0.875rem', color: '#666', marginTop: '0.25rem' }}>
                      {faq.respuesta.substring(0, 100)}{faq.respuesta.length > 100 ? '...' : ''}
                    </div>
                  </td>
                  <td style={{ padding: '1rem' }}>{getScopeName(faq)}</td>
                  <td style={{ padding: '1rem' }}>{faq.orden}</td>
                  <td style={{ padding: '1rem' }}>
                    <span style={{
                      padding: '0.25rem 0.75rem',
                      borderRadius: '9999px',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      background: faq.publicado ? '#D1FAE5' : '#FEE2E2',
                      color: faq.publicado ? '#065F46' : '#991B1B'
                    }}>
                      {faq.publicado ? 'Publicado' : 'Borrador'}
                    </span>
                  </td>
                  <td style={{ padding: '1rem', textAlign: 'right' }}>
                    <button
                      onClick={() => handleOpenModal(faq)}
                      style={{
                        background: '#3B82F6',
                        color: '#fff',
                        padding: '0.5rem 1rem',
                        borderRadius: '0.375rem',
                        border: 'none',
                        cursor: 'pointer',
                        marginRight: '0.5rem'
                      }}
                    >
                      Editar
                    </button>
                    <button
                      onClick={() => handleDelete(faq.id)}
                      style={{
                        background: '#EF4444',
                        color: '#fff',
                        padding: '0.5rem 1rem',
                        borderRadius: '0.375rem',
                        border: 'none',
                        cursor: 'pointer'
                      }}
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
              {filteredAndSortedFaqs().length === 0 && (
                <tr>
                  <td colSpan="5" style={{ padding: '2rem', textAlign: 'center', color: '#666' }}>
                    {faqs.length === 0 
                      ? 'No hay FAQs creados. Haz clic en "Crear FAQ" para empezar.'
                      : 'No se encontraron FAQs con los filtros seleccionados.'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          padding: '1rem'
        }}>
          <div style={{
            background: '#fff',
            borderRadius: '0.5rem',
            width: '100%',
            maxWidth: window.innerWidth < 768 ? '100%' : '600px',
            maxHeight: '90vh',
            overflow: 'auto',
            padding: window.innerWidth < 768 ? '1.5rem' : '2rem',
            position: 'relative'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
              <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', margin: 0 }}>
                {editingFaq ? 'Editar FAQ' : 'Crear FAQ'}
              </h2>
              <button
                type="button"
                onClick={() => setShowModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '2rem',
                  cursor: 'pointer',
                  color: '#9ca3af',
                  lineHeight: '1',
                  padding: '0',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '0.375rem',
                  transition: 'background-color 0.2s ease, color 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f3f4f6'
                  e.currentTarget.style.color = '#4b5563'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent'
                  e.currentTarget.style.color = '#9ca3af'
                }}
              >
                ×
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', fontWeight: '600', marginBottom: '0.5rem' }}>
                  Ámbito
                </label>
                <select
                  value={formData.scope_type}
                  onChange={(e) => setFormData({ ...formData, scope_type: e.target.value, scope_id: null, pagina: 'home' })}
                  style={{
                    width: '100%',
                    padding: '0.5rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '0.375rem'
                  }}
                  required
                >
                  <option value="page">Página</option>
                  <option value="tienda">Tienda</option>
                  <option value="evento">Evento</option>
                </select>
              </div>

              {formData.scope_type === 'page' && (
                <div style={{ marginBottom: '1rem' }}>
                  <label style={{ display: 'block', fontWeight: '600', marginBottom: '0.5rem' }}>
                    Página
                  </label>
                  <select
                    value={formData.pagina}
                    onChange={(e) => setFormData({ ...formData, pagina: e.target.value })}
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '0.375rem'
                    }}
                    required
                  >
                    <option value="home">Home</option>
                    <option value="marcas">Marcas</option>
                    <option value="eventos">Eventos</option>
                    <option value="ubicanos">Ubícanos</option>
                    <option value="contacto">Contacto</option>
                    <option value="trabaja">Trabaja con Nosotros</option>
                  </select>
                </div>
              )}

              {formData.scope_type === 'tienda' && (
                <div style={{ marginBottom: '1rem' }}>
                  <label style={{ display: 'block', fontWeight: '600', marginBottom: '0.5rem' }}>
                    Tienda
                  </label>
                  <select
                    value={formData.scope_id || ''}
                    onChange={(e) => setFormData({ ...formData, scope_id: e.target.value })}
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '0.375rem'
                    }}
                    required
                  >
                    <option value="">Seleccionar tienda</option>
                    {tiendas.map(t => (
                      <option key={t.id} value={t.id}>{t.nombre}</option>
                    ))}
                  </select>
                </div>
              )}

              {formData.scope_type === 'evento' && (
                <div style={{ marginBottom: '1rem' }}>
                  <label style={{ display: 'block', fontWeight: '600', marginBottom: '0.5rem' }}>
                    Evento
                  </label>
                  <select
                    value={formData.scope_id || ''}
                    onChange={(e) => setFormData({ ...formData, scope_id: e.target.value })}
                    style={{
                      width: '100%',
                      padding: '0.5rem',
                      border: '1px solid #d1d5db',
                      borderRadius: '0.375rem'
                    }}
                    required
                  >
                    <option value="">Seleccionar evento</option>
                    {eventos.map(e => (
                      <option key={e.id} value={e.id}>{e.nombre}</option>
                    ))}
                  </select>
                </div>
              )}

              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', fontWeight: '600', marginBottom: '0.5rem' }}>
                  Pregunta
                </label>
                <input
                  type="text"
                  value={formData.pregunta}
                  onChange={(e) => setFormData({ ...formData, pregunta: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '0.5rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '0.375rem'
                  }}
                  required
                />
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', fontWeight: '600', marginBottom: '0.5rem' }}>
                  Respuesta
                </label>
                <textarea
                  value={formData.respuesta}
                  onChange={(e) => setFormData({ ...formData, respuesta: e.target.value })}
                  rows="4"
                  style={{
                    width: '100%',
                    padding: '0.5rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '0.375rem'
                  }}
                  required
                />
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', fontWeight: '600', marginBottom: '0.5rem' }}>
                  Orden
                </label>
                <input
                  type="number"
                  value={formData.orden}
                  onChange={(e) => setFormData({ ...formData, orden: parseInt(e.target.value) })}
                  style={{
                    width: '100%',
                    padding: '0.5rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '0.375rem'
                  }}
                />
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <input
                    type="checkbox"
                    checked={formData.publicado}
                    onChange={(e) => setFormData({ ...formData, publicado: e.target.checked })}
                  />
                  <span style={{ fontWeight: '600' }}>Publicado</span>
                </label>
              </div>

              <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  style={{
                    padding: '0.5rem 1rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '0.375rem',
                    background: '#fff',
                    cursor: 'pointer'
                  }}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  style={{
                    padding: '0.5rem 1rem',
                    background: '#000',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '0.375rem',
                    cursor: 'pointer',
                    fontWeight: '600'
                  }}
                >
                  {editingFaq ? 'Actualizar' : 'Crear'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}
